import React from 'react';
import { Helmet } from 'react-helmet-async';
import Stats from '../../../components/Global/BannerCard/Stats/Stats';
import LIRC from '../../../components/Global/BannerCard/LIRC/LIRC';
import ExpertiseSection from '../../../components/Global/BannerCard/Expertise/ExpertiseSection';
import THC from '../../../components/Global/BannerCard/T&HC/THC';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import CyientGrid from '../../../components/Global/BannerCard/CyientGrid/CyientGrid';
import AerospaceAccelerator from '../../../components/Global/BannerCard/AerospaceAccelerator/AerospaceAccelerator';
import AwardsCarousel from '../../../components/Global/BannerCard/AwardsCarousel/AwardsCarousel';
import PartnerCarousel from '../../../components/Global/BannerCard/PartnerCarousel/PartnerCarousel';
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';
import CyientShowcase from '../../../components/Global/BannerCard/CyientShowcase/CyientShowcase';

const AerospaceDefense = () => {
  const canonicalUrl = `${process.env.REACT_APP_BASE_URL}/aerospace-defense`;
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <>
      <Helmet>
        <html lang="en" />
        <meta charSet="utf-8" />
        <title>Adithya Infinity</title>
        <meta
          name="description"
          content="Discover innovative aerospace and defense solutions from V Adithya Infinity Pvt Ltd. We deliver precision engineering, manufacturing support, and skilled workforce across India."
        />
        <meta
          name="keywords"
          content="Aerospace engineering India, defense technology, precision manufacturing, V Adithya Infinity, engineering services, aerospace staffing, defense projects, avionics support, India defense recruitment"
        />
        {isDevelopment ? (
          <meta name="robots" content="noindex, nofollow" />
        ) : (
          <link rel="canonical" href={canonicalUrl} />
        )}

        {/* Open Graph */}
        <meta property="og:title" content="Aerospace & Defense Solutions | V Adithya Infinity Pvt Ltd" />
        <meta
          property="og:description"
          content="Engineering and manufacturing solutions tailored for aerospace and defense sectors in India. Trusted by industry leaders."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content="https://www.adithyainfinity.com/assets/images/aerospace-banner.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Aerospace & Defense Solutions | V Adithya Infinity Pvt Ltd" />
        <meta
          name="twitter:description"
          content="Explore aerospace and defense engineering, staffing, and manufacturing services from V Adithya Infinity Pvt Ltd."
        />
        <meta
          name="twitter:image"
          content="https://www.adithyainfinity.com/assets/images/aerospace-banner.jpg"
        />

        {/* JSON-LD Structured Data: Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "V Adithya Infinity Pvt Ltd",
            url: canonicalUrl,
            logo: "https://www.adithyainfinity.com/assets/images/logo.png",
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-9876543210",
              contactType: "Customer Service",
              areaServed: "IN",
              availableLanguage: ["English", "Hindi", "Telugu"],
            },
            sameAs: [
              "https://www.linkedin.com/company/vadithyainfinity",
              "https://www.facebook.com/vadithyainfinity",
            ],
          })}
        </script>

        {/* JSON-LD Structured Data: Service */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "Aerospace & Defense Engineering and Staffing",
            provider: {
              "@type": "Organization",
              name: "V Adithya Infinity Pvt Ltd",
              url: "https://www.adithyainfinity.com",
              logo: "https://www.adithyainfinity.com/assets/images/logo.png",
            },
            areaServed: {
              "@type": "Country",
              name: "India",
            },
            description:
              "Specialized aerospace and defense services including design, manufacturing, skilled staffing, and digital transformation solutions across India.",
          })}
        </script>
      </Helmet>

      <div>
        <ContactPage
          title="OUR EXPERTISE"
          subTitle="Empowering growth through expertise"
          backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDw0NDQ0QDQ0NEBINDQ0NEBANDQ0NFRIWFhURFRUYHSggGBolGxUVITEhJSkrOi4uFx8/OD84Nyg5OisBCgoKDg0NFQ0NFSsZFRkrLS03LSsrKy03Ny0rKystLS03LS0rNy0tLS0tNysrLTc3Ny0tNystKy03Ny0tKy0tK//AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAAAQIHA//EACYQAQAABQUAAgMBAQEAAAAAAAADMdHh8AIUQVOSARFRYcGhsSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOIAKKACoAigApZFsAAC3LJfktyC3Vm/LWTAuJfkr+QU+/8Av8TJrX8/oEVMmZMD7/gnxn/pkwLFyxcAABAARUAAFQBAAAAUURQAMmCiZMyYirbhMmW5BS3Bky3IBbgyZbkFvwJflcmBklyTOTWv5AyS1/jOTWv5/QGSEyZkwW3CZItyZMC3BfgtyX5AQyZkwATJgqGTBT5D5QABABAUAFEVQABRARSwW5BSxk0tyCljJluQLr9pfkyYH2qZMyYC5/iZMyf6ADJmTAsFuTJgWLluUvyCoZMyYAICoAoCIAAAICgAAAoCioAKBbkQWyZMyYKJk1yYFxL8rkwBMmuTAM/xMmuTAEya5MCwmTMmC5JDJmTADJgCAKAAICAACAAoAAAKIKKAClkAUQEUEBbqyoKIAKgAqAAAAgCoAoAAIAAIAIAioDQn2AoCgAgogCgKKgAomTAFQEUTJgKIuTAEyagCAAZMFAAEVEFQFAABPtUQQABftAGkAFAAABRAFEUAD7UFQAVAAABUAAAAQFQAAEAEBU+w+wPtAAAAABfg+EX4BRPgBRBRQEBUFFEEFEFFEEFEFFEEFEAAAAAAQFD7T7A+flFQAAAAAAAAFEAVWVBRFAAAAAAAAAAAAAAAAABAVBAUQAAAAABAURQAAAAAAFQBVZUFEAURfkARQBFAE+AFEAAAEAFQAAAAAAQAAHvs4vTE8aqGzi9MTxqoAGzi9MTxqouzi9MTxqogC7OL1RPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9UTxqogC7OL1RPGqibOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAP/9k="
          highlightWord="EXPERTISE"
        />
        <Stats />
        <LIRC />
        <CyientGrid />
        <ExpertiseSection />
        <CyientShowcase />
        <THC />
        <AerospaceAccelerator />
        <AwardsCarousel />
        <PartnerCarousel />
        <MakeTheShift />
      </div>
    </>
  );
};

export default AerospaceDefense;
